import React from "react";
import { get } from "../../../containers/activite/map/map.utils";
import DetailPdcContainer from "../../../containers/metier/pdc/detail.pdc.container";

const Home = ({ match }) => {
  const pdcId = get(["params", "id"], match, 0);
  return <DetailPdcContainer pdcId={pdcId}></DetailPdcContainer>;
};

export default Home;



// WEBPACK FOOTER //
// src/pages/basepdc/detailPdc/Home.detailpdc.js